import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { tGetMetaPagesData } from '../../../../../../../providers/IntegrationsProvider/Integrations.types.ts';
import { useMetaConnectionModalContext } from '../../MetaConnectionModal.hook.ts';
import MetaPage from '../MetaPage/MetaPage.component.tsx';
import useMetaStepAllPages from './MetaStepAllPages.hook.ts';
import './MetaStepAllPages.styles.scss';

export default function MetaStepAllPages() {
  const { metaPages } = useMetaConnectionModalContext();
  const { getAllPages } = useMetaStepAllPages();
  const { t } = useTranslation('dashboard/dashboard');

  const filterMetaPagesByOnlyFacebook = (pages: tGetMetaPagesData[]) => {
    return pages.filter((page) => page.page_type === 'FACEBOOK');
  };

  return (
    <div className="MetaStepAllPages">
      <p className="MetaStepAllPages__Warning">
        ⚠️ Puedes conectar solo 1 página de Facebook y 1 cuenta de Instagram
      </p>
      <h3 className="MetaStepAllPages__Subtitle">
        Páginas de Facebook e Instagram disponibles:
      </h3>
      {filterMetaPagesByOnlyFacebook(metaPages).map((page, index) => (
        <MetaPage key={index} {...page} />
      ))}
      <Button
        color="primary"
        className="text-base-100 MetaStepAllPages__Button"
        onClick={getAllPages}
      >
        {t('components.modals.MetaConnection.updateButton')}
      </Button>
      <a
        className="MetaStepAllPages__Link"
        href="https://www.skool.com/leadsales-academy/classroom/799361ca?md=001bf2d0b9524b30aab6b7034fc996b6"
        target="_blank"
        rel="noopener noreferrer"
      >
        ¿Por qué no puedo seleccionar algunas páginas?
      </a>
    </div>
  );
}
